const intialState = {
  user: {
    username: '',
    email: '',
  },
};

const userReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case 'user/updateUser':
      return {
        ...state,
        user: action.payload,
      };
    case 'user/getUser':
      return state;
    default:
      return state;
  }
};

export default userReducer;
